// eslint-disable-next-line import/no-cycle
import NetworkAuth from '@/helpers/networking/NetworkAuth';
// eslint-disable-next-line import/no-cycle
import store from '@/store';

/** Apply checkToken / ping payload to auth store (login contract). */
export function applySessionPingPayload(data) {
  if (!data || typeof data !== 'object') return;
  store.commit('updateUserRoles', data.roles ?? []);
  if (typeof data.customerLayoutRevision === 'number') {
    store.commit('setCustomerLayoutRevision', data.customerLayoutRevision);
  }
  if (data.layoutUnchanged) return;
  store.commit('setCustomerNavigation', data.customerNavigation ?? []);
  store.commit('setHomeScreenLayout', data.homeScreenLayout ?? []);
  store.commit('setFeatureDisplayByKey', data.featureDisplayByKey ?? {});
  store.commit('setFeatureAccessByKey', data.featureAccessByKey ?? {});
}

/**
 * Refresh roles + layout from ping. Requires JWT (non-Keycloak).
 * @throws when ping fails (expired session)
 */
export async function refreshSessionFromPing() {
  const token = store.state.auth.token;
  if (!token) {
    throw new Error('No auth token');
  }
  const layoutRevision = store.getters.getCustomerLayoutRevision ?? 0;
  const { data } = await NetworkAuth.checkIfUserLoggedIn(
    { layoutRevision },
    { headers: { Authorization: token } },
  );
  applySessionPingPayload(data);
}
